import React from "react";
import { useOrg } from "../../../contexts/OrganizationContext";

function ListingUpdateTypeSelection({ show, onClose, onShowNoteForm, reportIssueLink }) {
  const { organization } = useOrg();

  if (!show) return null;

  const serviceName = organization?.serviceName || window.UW211?.ORGANIZATION?.serviceName || "211";

  function handleSuggestEdit(e) {
    e.preventDefault();
    if (reportIssueLink) {
      window.open(reportIssueLink, '_blank', 'noopener,noreferrer');
    }
    onClose();
  }

  function handleShowNoteForm(e) {
    e.preventDefault();
    onShowNoteForm();
  }

  return (
    <div className="modal update-type-selection-modal updateTypeSelectionModal" role="dialog" tabIndex="-1" style={{ display: "block", zIndex: 9999 }}>
      <div className="modal-backdrop fade in" onClick={onClose} style={{ zIndex: -1 }} />
      <div className="modal-dialog modal-lg" role="document">
        <div className="share-content">
          <div className="modal-content">
            <div className="modal-header">
              <a className="close-modal" aria-label="Close" onClick={onClose} role="button">
                <span aria-hidden="true">&times;</span>
              </a>
              <h4 className="sub-headliner">Submit an update to this listing</h4>
              <p>
                At {serviceName}, our goal is to keep the online directory current
                and relevant in order to best connect our users with the resources
                they need. If you see information in a program listing that is
                outdated or incorrect, we want to hear from you. {reportIssueLink ? 'You can submit edits in two ways:' : ''}
              </p>
            </div>
            <div className="modal-body">
              <div className="row update-type-selection-row">
                <div className="col-md-6" style={{ textAlign: "center", ...(reportIssueLink ? { borderRight: "1px solid #e5e5e5" } : { width: "100%" }) }}>
                  <h5 className="sub-headliner">Publish a note on this listing</h5>
                  <p>
                    You may publish a note to inform us of inaccurate or missing information.
                    Your note will be immediately and publicly displayed on this website and
                    later reviewed by 211 staff. Once 211 Resource staff have reviewed your
                    note and make the necessary changes to the resource listing, your note will
                    be removed.
                  </p>
                  <button className="show-note-form-button btn btn-primary" name="Add" onClick={handleShowNoteForm}>
                    Submit a note
                  </button>
                </div>
                {reportIssueLink && (
                  <div className="col-md-6" style={{ textAlign: "center" }}>
                    <h5 className="sub-headliner">Suggest an edit</h5>
                    <p>
                      Suggest an edit that is not displayed publicly on the website
                      and is forwarded to, and reviewed by, 211 Resource staff.
                      They will make the appropriate changes to the listing.
                    </p>
                    <button className="btn btn-default" name="Add" onClick={handleSuggestEdit}>
                      Suggest an edit
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ListingUpdateTypeSelection;
